<template>
  <div class="q-echart">
    <div class="topContent">
      <div class="title">{{currentType == 'labour' ? 'Labour' : 'Revenue'}} Daily Trend</div>
      <div class="rightContent">
        <div class="legend">
          <span class="legend1">Target</span>
          <span class="legend2">Actual</span>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="chartsContent d-flex align-items-center justify-content-center">
        <!-- Display Echart -->
        <ECharts v-if="!loading" ref="lineChart" :option="lineOptions" class="lineChart"></ECharts>
        <!-- Display Skeleton -->
        <div class="graph-fake-load d-flex flex-column" v-if="loading">
          <el-skeleton animated>
            <template slot="template">
              <div class="graph-fake-wrapper d-flex flex-column gap-10">
                <div class="d-flex h-100 gap-16px">
                  <div class="d-flex w-100 h-100 justify-content-between flex-column">
                    <div class="d-flex w-100 align-items-center gap-10" v-for="item in 8" :key="item">
                      <el-skeleton-item variant="text" style="width: 35px;" />
                      <el-skeleton-item variant="text" style="width: 100%; height: 0.5px;" />
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between" style="gap: 7px;">
                  <el-skeleton-item v-for="item in 24" :key="item" variant="text" style="width: 100%;" />
                </div>
              </div>
            </template>
          </el-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts';
import api from '../../../api/dashboard';

export default {
    name: 'Chart',
    components: {
        ECharts
    },
    props: {
        currentType: {
            type: String,
            required: true,
            default: 'labour'
        },
        date: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            chartData: [],
            loading: false,
            lineOptions: {
                // Color configuration
                color: ["#ffffff","#2FCBFF"],
                // Tooltip on mouse hover
                tooltip: {
                backgroundColor: process.env.PRIMARY_COLOR ? process.env.PRIMARY_COLOR : '#EA3796',
                borderColor: process.env.PRIMARY_COLOR ? process.env.PRIMARY_COLOR : '#EA3796',
                trigger: 'axis',
                textStyle: {
                    color: 'white',
                    'fontFamily': 'PingFang SC-Regular, PingFang SC'
                },
                axisPointer: {type: 'line'},
                valueFormatter:value => {
                    let num = parseFloat(value),
                    valueText = (num.toString().indexOf ('.') !== -1) ?
                    num.toLocaleString():num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
                    return value !== null && value !== undefined ? `$${valueText}` : '-';
                }
                },
                grid: {
                    top: '5%',
                    left: '4%',
                    right: '3%',
                    bottom: '8%'
                },
                // Legend
                legend: {
                    show:false,
                    right: 30,
                    icon:'circle',
                    position:'right',
                    data: ['Target', 'Actual',],
                },
                // X-axis
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        show:true,
                        alignWithLabel: true
                    },
                    axisLabel:{
                        fontFamily: 'PingFang SC-Medium',
                        color: '#657291',
                        margin: 13,
                    },
                }],
                // Y-axis
                yAxis: [{ 
                    type: 'value',
                    axisLine: {show: false,},
                    splitLine :{
                      lineStyle:{
                        opacity:0.1
                      },
                      show: true
                    },
                    axisLabel:{
                        color: process.env.PRIMARY_COLOR ? process.env.PRIMARY_COLOR : '#657291',
                        fontFamily: 'PingFang SC-Medium',
                        formatter (val) {
                            return val > 1000?val/1000+'k': val;
                        }
                    }
                }],
                // Data format
                series: [
                {
                  name: 'Target',
                  type: 'line',
                  data: [],
                  smooth: true,
                  showSymbol: false,
                },
                {
                  name: 'Actual',
                  type: 'line',
                  data: [],
                  smooth: true,
                  showSymbol: false,
                }
              ],
            }
        }
    },
    watch: {
        date: {
            handler() {
                this.getChartData()
            },
        }
    },
    methods: {
        async getChartData() {
            this.loading = true
            // Initialize series
            const series = [];
            // Get chart data
            const data = await api.getChartData(this.date, this.currentType)

            if (data) {
                // Set chart data
                this.chartData = data
                // Set chart series
                if (this.chartData.series && this.chartData.series.length > 0) {
                    // Loop through each series
                    this.chartData.series.forEach(item => {
                        // Get data
                        let data = item.data.map(item => item.value)
                        // Push target or actual data to series
                        series.push({
                            name: item.name,
                            data: data,
                            smooth: true,
                            showSymbol: false,
                            type: 'line',
                            connectNulls: false, // Don't connect null values
                        })
                    })
                    // Get target data
                  const targetData = this.chartData.series.find(item => item.name === 'Target');

                  // Set x-axis data
                   if (targetData) {
                    this.lineOptions.xAxis[0].data = targetData.data.map(item => item.label)
                   }

                   // Set series data
                   if (series.length > 0) {
                    this.lineOptions.series = series
                   }
                }
            }

            this.loading = false

        }
    },
    mounted() {
        // Add event listener for window resize
        window.addEventListener("resize", () => {
            // Resize chart when window is resized for responsive purpose
            if (this.$refs.lineChart && !this.loading){
                this.$refs.lineChart.resize();
            }
        });

        // Get chart data when component is mounted
        this.getChartData()
    }
}
</script>

<style lang="scss" src="@/assets/css/echart.scss" scoped></style>


// WEBPACK FOOTER //
// src/components/dashboard/component/chart.vue